import { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { FddApi } from "../../../ui/services/server-fdd";
import { useNotification } from "../../../ui/context/notification/NotificationContext";

const MAX_FILE_SIZE_MB = 20;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const useDrop = () => {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const [error, setError] = useState(null);

    const onDrop = useCallback(async(acceptedFiles = [], fileRejections = []) => {
        if (fileRejections.length > 0) {
            const rejection = fileRejections[0];
            const errorCode = rejection.errors[0]?.code;

            let message = 'Archivo no válido. Intenta con otro documento.';
            if (errorCode === 'file-too-large') {
                message = `El archivo es demasiado grande. El tamaño máximo permitido es ${MAX_FILE_SIZE_MB} MB.`;
            } else if (errorCode === 'file-invalid-type' || errorCode === '01') {
                message = 'Solo se permiten archivos PDF (.pdf).';
            } else if (errorCode === 'too-many-files') {
                message = 'Solo puedes subir un archivo a la vez.';
            }

            setError(message);
            showNotification(message, 'error', 6000);
            return;
        }

        setError(null);
        const response = FddApi.createDraft(acceptedFiles[0]);

        response.then((response) => {
            if(response.hasError) {
                showNotification('Error al crear el borrador. Intenta nuevamente.', 'error', 6000);
                return;
            }

            navigate(`draft/${response.draftId}`,
                {
                    state: {
                        filename: acceptedFiles[0].name,
                    }
                }
            );
        });

        return;

    }, [navigate, showNotification]);

    const dropzoneProps = useMemo(() => ({
        onDrop,
        validator: typeFileValidator,
        maxFiles: 1,
        maxSize: MAX_FILE_SIZE_BYTES,
        accept: {
            "application/pdf": [".pdf"],
        },
    }), [onDrop]);

    const { getRootProps, getInputProps } = useDropzone(dropzoneProps);

    return {
        getRootProps,
        getInputProps,
        error,
    };
};

// Manejo de errores de tipo de archivo
const typeFileValidator = ({ path }) => {
    if (!path?.endsWith(".pdf")) {
        return {
            code: "01",
            message: `Solo se permiten archivos PDF. El archivo "${path}" no es válido.`,
        };
    }
};

export default useDrop;